<div *ngFor="let section of sections">
  <h4 *ngIf="section.heading">{{ section.heading }}</h4>
  <p *ngIf="section.category !== 'exceptions'">
    <strong>{{ section.title }}</strong>
  </p>
  <app-api-reference-note-section [noteSections]="section.noteSections || []"></app-api-reference-note-section>
  <div [innerHTML]="section.body | mdToHtml"></div>
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
